import { styled } from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const ScrollArea = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;

    @media (max-width: 1116px) {
        overflow: hidden;
        overflow-x: auto;
    }
`;
